<template>

  <div class="ob-content">
    <v-card>
      <planned-issues-table :source="source" @click="$router.push({ name: 'planned-issue-definitions/id', params: { id: $event.id} })" />
    </v-card>

    <v-btn fab fixed bottom right color="primary" @click="$router.push({ name: 'planned-issue-definitions/new' })">
      <v-icon>add</v-icon>
    </v-btn>
  </div>

</template>

<script>
import ApiService from '../../services/api.service.es6'
import PlannedIssuesTable from './components/planned-issues-table'


export default {
  data () {
    return {
      source: args => ApiService.findAllPaginated('planned-issue-definitions', null, args.sort, args.pagination)
    }
  },

  components: {
    PlannedIssuesTable
  }
}
</script>
